export const GET_RULE_ENTITIES_REQUEST = 'GET_RULE_ENTITIES_REQUEST';
export const GET_RULE_ENTITIES_SUCCESS = 'GET_RULE_ENTITIES_SUCCESS';
export const GET_RULE_ENTITIES_ERROR = 'GET_RULE_ENTITIES_ERROR';
